import Shepherd from 'shepherd.js';
import { t9n } from './translate';
import { TS } from '../config/translation-keys';
import session from './session';
import APIClient from '../state-charts/api-client';
import { offset } from '@floating-ui/core';

let tour;
let scroll_to = false;

// translated strings ------------------------------------------------------ //

let next;
let ok_label;
let yes_label;
let cancel_label;
let skip_tutorial;
let finish_label;
let worker_tutorial_00, worker_tutorial_01, worker_tutorial_01b, worker_tutorial_02, worker_tutorial_02b, worker_tutorial_03,
  worker_tutorial_04, worker_tutorial_05, worker_tutorial_06, worker_tutorial_07, worker_tutorial_08a, worker_tutorial_08b;

let orderer_tutorial_01, orderer_tutorial_02, orderer_tutorial_02b, orderer_tutorial_03, orderer_tutorial_04, orderer_tutorial_05, orderer_tutorial_06, orderer_tutorial_07;

let new_order_tutorial_00, new_order_tutorial_01, new_order_tutorial_02, new_order_tutorial_03, new_order_tutorial_04, new_order_tutorial_05,
  new_order_tutorial_06, new_order_tutorial_07, new_order_tutorial_08, new_order_tutorial_09, new_order_tutorial_10, new_order_tutorial_11, new_order_tutorial_12;

const translate_texts = () => {
  ok_label = t9n(TS.REG_FORM_OK);
  skip_tutorial = t9n(TS.SKIP_TUTORIAL);
  next = t9n(TS.TABLE_BUTTON_NEXT);
  yes_label = t9n(TS.TXT_YES);
  cancel_label = t9n(TS.TXT_CANCEL);
  finish_label = t9n(TS.TUTORIAL_FINISH);
  worker_tutorial_00 = t9n(TS.WORKER_TUTORIAL_00);
  worker_tutorial_01 = t9n(TS.WORKER_TUTORIAL_01);
  worker_tutorial_01b = t9n(TS.WORKER_TUTORIAL_01B);
  worker_tutorial_02 = t9n(TS.WORKER_TUTORIAL_02);
  worker_tutorial_02b = t9n(TS.WORKER_TUTORIAL_02B);
  worker_tutorial_03 = t9n(TS.WORKER_TUTORIAL_03);
  worker_tutorial_04 = t9n(TS.WORKER_TUTORIAL_04);
  worker_tutorial_05 = t9n(TS.WORKER_TUTORIAL_05);
  worker_tutorial_06 = t9n(TS.WORKER_TUTORIAL_06);
  worker_tutorial_07 = t9n(TS.WORKER_TUTORIAL_07);
  worker_tutorial_08a = t9n(TS.WORKER_TUTORIAL_08A);
  worker_tutorial_08b = t9n(TS.WORKER_TUTORIAL_08B);
  orderer_tutorial_01 = t9n(TS.ORDERER_TUTORIAL_01);
  orderer_tutorial_02 = t9n(TS.ORDERER_TUTORIAL_02);
  orderer_tutorial_02b = t9n(TS.ORDERER_TUTORIAL_02B);
  orderer_tutorial_03 = t9n(TS.ORDERER_TUTORIAL_03);
  orderer_tutorial_04 = t9n(TS.ORDERER_TUTORIAL_04);
  orderer_tutorial_05 = t9n(TS.ORDERER_TUTORIAL_05);
  orderer_tutorial_06 = t9n(TS.ORDERER_TUTORIAL_06);
  orderer_tutorial_07 = t9n(TS.ORDERER_TUTORIAL_07);
  new_order_tutorial_00 = t9n(TS.NEW_ORDER_TUTORIAL_00);
  new_order_tutorial_01 = t9n(TS.NEW_ORDER_TUTORIAL_01);
  new_order_tutorial_02 = t9n(TS.NEW_ORDER_TUTORIAL_02);
  new_order_tutorial_03 = t9n(TS.NEW_ORDER_TUTORIAL_03);
  new_order_tutorial_04 = t9n(TS.NEW_ORDER_TUTORIAL_04);
  new_order_tutorial_05 = t9n(TS.NEW_ORDER_TUTORIAL_05);
  new_order_tutorial_06 = t9n(TS.NEW_ORDER_TUTORIAL_06);
  new_order_tutorial_07 = t9n(TS.NEW_ORDER_TUTORIAL_07);
  new_order_tutorial_08 = t9n(TS.NEW_ORDER_TUTORIAL_08);
  new_order_tutorial_09 = t9n(TS.NEW_ORDER_TUTORIAL_09);
  new_order_tutorial_10 = t9n(TS.NEW_ORDER_TUTORIAL_10);
  new_order_tutorial_11 = t9n(TS.NEW_ORDER_TUTORIAL_11);
  new_order_tutorial_12 = t9n(TS.NEW_ORDER_TUTORIAL_12);
};

const check_mobile = () => {
  let check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const check_tutorial = async (tutorial_screen = 'none') => {
  let tutorials = await APIClient.get_tutorial();
  if (tutorials.hasOwnProperty('tutorials')) {
    if (tutorial_screen === 'none') return !!tutorials && tutorials.tutorials.length > 0;
    if (tutorials.tutorials.includes(tutorial_screen)) return true;
  }
  return false;
};

const check_role = (role, reset, id) => {
  if (role === 'no_role_yet') {
      init_welcome();
  } else if (role === 'orderer') {
      if (document.tour === undefined || reset) {
        if (id.substring(0, 5) === 'tour_') {
          init_orderer_tour();
          console.warn('init_orderer_tour called from show_tutorial_screen');
        } else if (id.substring(0, 5) === 'new_o') {
          init_new_order_tutorial();
          console.warn('init_new_order_tutorial called from show_tutorial_screen');
        }
      } else {
        console.warn('document.tour orderer error', document.tour);
      }
  } else if (role === 'worker') {
      if (document.tour === undefined || reset) {
        init_worker_tour();
        console.warn('init_worker_tour called from show_tutorial_screen');
      } else {
        console.warn('document.tour worker error', document.tour);
      }
  } else {
      console.warn('Error: no \'role\' selected in tutorials!');
  }
}

/**
 * @param session_tut = is session.tutorial set
 * @param id = the tutorial message to be shown
 * @param timeout = wait for the message to be shown
 * @param role = which role ('orderer')
 * @param reset = replay all tutorials, default is false
 */
export const show_tutorial_screen = (
  session_tut,
  id,
  timeout = 400,
  role = 'worker',
  reset = false,
) => {
  if (session_tut === true) {
    check_role(role, reset, id);
    setTimeout(() => {document.tour.show(id)}, timeout);
  } else {
    console.warn(`this ${id} tutorial screen was called, but there is no session.tutorial set`);
  }
};

const update_tutorials = async () => {
  let tutorial_list = [];
  let tour = window.localStorage.getItem('WP.tutorial')
  let new_order = window.localStorage.getItem('WP.tutorial.new_order')
  if (tour === 'true') tutorial_list.push('intro')
  if (new_order === 'true') tutorial_list.push('new_order')
  await APIClient.put_tutorial({ tutorials: tutorial_list });
}

const dismiss_tour = async () => {
  window.localStorage.setItem('WP.tutorial.new_order', 'false');
  await update_tutorials();
  return tour.complete()
}

/* Tour steps */

export const init_welcome = () => {
  translate_texts();
  scroll_to = check_mobile();
  tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: false,
    defaultStepOptions: {
      classes: 'shepherd-additional',
      scrollTo: { behavior: 'smooth', block: 'center' },
    },
  });

  tour.addStep({
    id: 'tour_w1',
    title: worker_tutorial_00,
    text: worker_tutorial_01,
    attachTo: {
      element: '#dialog-surface-first-time-role-selector-dialog',
      on: 'bottom',
    },
    classes: 'shepherd-home',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: skip_tutorial,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w1b',
    text: worker_tutorial_01b,
    attachTo: {
      element: '#dialog-surface-first-time-role-selector-dialog',
      on: 'bottom',
    },
    classes: 'shepherd-home',
    buttons: [
      {
        text: ok_label,
        action: async () => {
          window.localStorage.setItem('WP.tutorial', 'false');
          await update_tutorials()
          return tour.complete();
        },
      },
    ],
  });

  document.tour = tour;
}

export const init_new_order_tutorial = () => {
  translate_texts();
  scroll_to = check_mobile();
  tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
      classes: 'shepherd-additional',
      scrollTo: { behavior: 'smooth', block: 'center' },
      when: {
        show: function() {
          const currentStepElement = tour.currentStep.el;
          const header = currentStepElement.querySelector('.shepherd-footer');
          //create progress holder
          const progress = document.createElement('div');
          //create the progress bar
          const innerBar = document.createElement('span');
          //calculate the progress in percentages
          const progressPercentage = ((tour.steps.indexOf(tour.currentStep) + 1)/tour.steps.length)*100 + '%';

          //add class to the progress holder
          progress.className='shepherd-progress-bar';
          //add the width dynamically
          innerBar.style.width=progressPercentage;
          //if it is only one button, expand progress holder
          if (document.getElementsByClassName('shepherd-button').length==1) {
            progress.style.minWidth = '260px';
          }
          progress.appendChild(innerBar);
          header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
        }
      }
    },
  });

  tour.addStep({
    id: 'new_order_o1',
    text: new_order_tutorial_00,
    classes: 'shepherd-home, shepherd-no-pad-buttons',
    buttons: [
      {
        text: cancel_label,
        action: async () => {
          window.localStorage.setItem('WP.tutorial.new_order', 'false');
          await update_tutorials();
          return tour.complete();
        },
      },
      {
        text: yes_label,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o2',
    text: new_order_tutorial_01,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#task-description',
      on: 'bottom',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o3',
    text: new_order_tutorial_02,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#selector-category-select',
      on: 'bottom',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o4',
    text: new_order_tutorial_03,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#text-field',
      on: 'right',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('new_order_o1');
          return tour.hide();
        },
      },
    ],
  });

  //target
  tour.addStep({
    id: 'new_order_o5',
    text: new_order_tutorial_04,
    scrollTo: scroll_to,
    attachTo: {
      element: '#team-code',
      on: 'top',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('new_order_o4');
          return tour.hide();
        },
      },
    ],
  });

  //location
  tour.addStep({
    id: 'new_order_o6',
    text: new_order_tutorial_05,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#text_field_searchbox',
      on: 'bottom',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('new_order_o5');
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o7',
    text: new_order_tutorial_06,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#address-sec',
      on: 'left',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('new_order_o6');
          return tour.hide();
        },
      },
    ],
  });

  //time
  tour.addStep({
    id: 'new_order_o8',
    text: new_order_tutorial_07,
    // scrollTo: scroll_to,
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o9',
    text: new_order_tutorial_08,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#start-date-date',
      on: 'bottom',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o10',
    text: new_order_tutorial_09,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#task-done',
      on: 'bottom',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'new_order_o11',
    text: new_order_tutorial_10,
    scrollTo: scroll_to,
    attachTo: {
      element: '#duration',
      on: 'right',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep("new_order_o8")
          return tour.hide();
        },
      },
    ],
  });

  //payment
  tour.addStep({
    id: 'new_order_o12',
    text: new_order_tutorial_11,
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep("new_order_o12")
          return tour.hide();
        },
      },
    ],
  });

  //summary
  tour.addStep({
    id: 'new_order_o13',
    text: new_order_tutorial_12,
    scrollTo: scroll_to,
    /*    attachTo: {
          element: '#myDialog',
          on: 'top',
        },*/
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: finish_label,
        action: async () => {
          window.localStorage.setItem('WP.tutorial.new_order', 'false');
          await update_tutorials();
          return tour.complete();
        },
      },
    ],
  });

  tour.on('cancel', dismiss_tour);
  document.tour = tour;
};

export const init_orderer_tour = () => {
  translate_texts();
  scroll_to = check_mobile();
  tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: false,
    defaultStepOptions: {
      classes: 'shepherd-additional',
      scrollTo: { behavior: 'smooth', block: 'center' },
      when: {
        show: function() {
          const currentStepElement = tour.currentStep.el;
          const header = currentStepElement.querySelector('.shepherd-footer');
          //create progress holder
          const progress = document.createElement('div');
          //create the progress bar
          const innerBar = document.createElement('span');
          //calculate the progress in percentages
          const progressPercentage = ((tour.steps.indexOf(tour.currentStep) + 1)/tour.steps.length)*100 + '%';

          //add class to the progress holder
          progress.className='shepherd-progress-bar';
          //add the width dynamically
          innerBar.style.width=progressPercentage;
          //if it is only one button, expand progress holder
          if (document.getElementsByClassName('shepherd-button').length==1) {
            progress.style.minWidth = '260px';
          }
          progress.appendChild(innerBar);
          header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
        }
      }
    },
  });

  tour.addStep({
    id: 'tour_w2',
    text: orderer_tutorial_01,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#org-type-select',
      on: 'top',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w2b',
    text: orderer_tutorial_02,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#prof-img',
      on: 'left',
    },
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('tour_w2');
          return tour.hide();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w3',
    text: orderer_tutorial_02b,
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: ok_label,
        action: function() {
          tour.removeStep('tour_w2b');
          window.localStorage.setItem('WP.tutorial_part2', 'true');
          return tour.hide();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w5',
    text: orderer_tutorial_03,
    scrollTo: false,
    attachTo: {
      element: '#new_order',
      on: 'bottom',
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w5b',
    text: orderer_tutorial_04,
    scrollTo: false,
    attachTo: {
      element: '.home-hexa-apps',
      on: 'bottom',
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w6',
    text: orderer_tutorial_05,
    attachTo: {
      element: '#noti-button',
      on: 'bottom',
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('tour_w5');
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w7',
    text: orderer_tutorial_06,
    attachTo: {
      element: '#side_menu',
      on: 'right',
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w8',
    text: orderer_tutorial_07,
    buttons: [
      {
        text: finish_label,
        action: async () => {
          session.value().tutorial = false;
          window.localStorage.setItem('WP.tutorial_part2', 'false');
          window.localStorage.setItem('WP.tutorial', 'false');
          await update_tutorials()
          return tour.complete();
        },
      },
    ],
  });

  document.tour = tour;
};

export const init_worker_tour = () => {
  translate_texts();
  scroll_to = check_mobile();
  tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: false,
    defaultStepOptions: {
      classes: 'shepherd-additional',
      scrollTo: { behavior: 'smooth', block: 'center' },
      when: {
        show: function() {
          const currentStepElement = tour.currentStep.el;
          const header = currentStepElement.querySelector('.shepherd-footer');
          //create progress holder
          const progress = document.createElement('div');
          //create the progress bar
          const innerBar = document.createElement('span');
          //calculate the progress in percentages
          const progressPercentage = ((tour.steps.indexOf(tour.currentStep) + 1)/tour.steps.length)*100 + '%';

          //add class to the progress holder
          progress.className='shepherd-progress-bar';
          //add the width dynamically
          innerBar.style.width=progressPercentage;
          //if it is only one button, expand progress holder
          if (document.getElementsByClassName('shepherd-button').length==1) {
            progress.style.minWidth = '260px';
          }
          progress.appendChild(innerBar);
          header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
        }
      }
    },
  });

  tour.addStep({
    id: 'tour_w2',
    text: worker_tutorial_02,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#task-description',
      on: 'top',
    },
    classes: 'shepherd-text',
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w2b',
    text: worker_tutorial_02b,
    // scrollTo: scroll_to,
    attachTo: {
      element: '#prof-img',
      on: 'left',
    },
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: ok_label,
        action: function() {
          tour.removeStep('tour_w2');
          window.localStorage.setItem('WP.tutorial_part2', 'true');
          // APIClient.put_tutorial({"tutorials":["tour_w1, tour_w2, tour_w3, tour_w4, tour_w5, tour_w6, tour_w7, tour_w8"]})
          return tour.hide();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w3',
    text: worker_tutorial_03,
    attachTo: {
      element: '#text_field_searchbox',
      on: 'bottom',
    },
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('tour_w2b');
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w4',
    text: worker_tutorial_04,
    attachTo: {
      element: '#duration',
      on: 'bottom',
    },
    floatingUIOptions: {
      middleware: [offset(25)],
    },
    buttons: [
      {
        text: ok_label,
        action: function() {
          tour.removeStep('tour_w3');
          //APIClient.put_tutorial({"tutorials":["tour_w1, tour_w2, tour_w3, tour_w4, tour_w5, tour_w6, tour_w7, tour_w8"]})
          return tour.hide();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w5',
    text: worker_tutorial_05,
    scrollTo: false,
    attachTo: {
      element: '.home-hexa-apps',
      on: 'bottom',
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w6',
    text: worker_tutorial_06,
    attachTo: {
      element: '#noti-button',
      on: 'bottom',
    },
    buttons: [
      {
        text: next,
        action: function() {
          tour.removeStep('tour_w5');
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w7',
    text: worker_tutorial_07,
    attachTo: {
      element: '#side_menu',
      on: 'right',
    },
    buttons: [
      {
        text: next,
        action: function() {
          return tour.next();
        },
      },
    ],
  });

  tour.addStep({
    id: 'tour_w8',
    title: worker_tutorial_08a,
    text: worker_tutorial_08b,
    buttons: [
      {
        text: finish_label,
        action: async () => {
          session.value().tutorial = false;
          window.localStorage.setItem('WP.tutorial_part2', 'false');
          window.localStorage.setItem('WP.tutorial', 'false');
          await update_tutorials()
          return tour.complete();
        },
      },
    ],
  });

  document.tour = tour;
};
